import { ApiClient } from "./client"
import type { CellsBundle } from "./book"

export interface TemplateMeta {
  template_id: string
  name: string
  version: string
  lang: string
  total_pages: number
  public: boolean
  owner_sub: string
  created_at: number
}

export interface TemplateDetail {
  template: TemplateMeta & {
    pdf_key: string
    cells_key: string
    sections: Array<{
      kind: string
      label: string
      labels?: Record<string, string>
      first_page: number
      last_page: number
      week_idx?: number | null
    }>
    mapping: { regex: string; groups: string[] }
  }
  template_url: string
  cells: CellsBundle
}

export interface FormInstance {
  form_id: string
  template: TemplateDetail["template"]
  template_url: string
  cells: CellsBundle
  values: Record<string, string>
  instance_key: string
  entries?: Record<string, Array<{
    id: string; date: string;
    description?: string; amount_eur: number;
    istat_category?: string; istat_label?: string;
    source?: string; edited_by_user?: boolean;
  }>>
}

export function listTemplates(api: ApiClient) {
  return api.get<{ items: TemplateMeta[] }>(`/templates`)
}

export function getTemplate(api: ApiClient, templateId: string) {
  return api.get<TemplateDetail>(`/templates/${encodeURIComponent(templateId)}`)
}

export interface CreateTemplateBody {
  template_id: string
  name: string
  version: string
  lang: string
  sections: TemplateDetail["template"]["sections"]
  mapping: TemplateDetail["template"]["mapping"]
  public: boolean
  pdf_base64: string
  cells_json: CellsBundle
  total_pages?: number
}

export function createTemplate(api: ApiClient, body: CreateTemplateBody) {
  return api.post<TemplateMeta>(`/templates`, body)
}

export function openForm(api: ApiClient, templateId: string, instanceKey: string) {
  return api.get<FormInstance>(`/forms/${encodeURIComponent(templateId)}/${encodeURIComponent(instanceKey)}`)
}

export function saveTemplateCells(api: ApiClient, templateId: string, cells: CellsBundle) {
  return api.put<{ ok: boolean; template_id: string; cells_key: string; total_cells: number }>(
    `/templates/${encodeURIComponent(templateId)}/cells`,
    { cells }
  )
}

export function saveFormValues(api: ApiClient, formId: string, values: Record<string, string>) {
  return api.put<{ form_id: string; updated_at: number; saved_count: number }>(
    `/forms/${encodeURIComponent(formId)}/values`,
    { values }
  )
}
